
import React from 'react';

const SuggestionBox = () => {
  return (
    <div className="mt-6 p-8 bg-blue-50 rounded-lg">
      <h2 className="text-xl font-bold mb-4">Have a Calculator Suggestion?</h2>
      <p className="text-gray-700">
        We're constantly adding new specialized calculators. If you have a suggestion for a calculator you'd like to see, please let us know!
      </p>
    </div>
  );
};

export default SuggestionBox;
